import { flowIdCompanyScanBE, flowIdCompanyScanNL } from '../constants/flowIds';

export const hasSubGroups = (flowId?: string): boolean => {
  if (!flowId) return false;
  return [flowIdCompanyScanBE, flowIdCompanyScanNL].includes(flowId);
};
